import React, {SVGProps} from 'react';

import {ReactComponent} from '../../assets/svg/gps_fixed.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
